import {
  UPDATE_SEARCHTDATA,
} from "../../actions/ChoThongTin/DanhSachVay/actionTypes";

const initialState = {
  iPageIndex: 1,
  iPageSize: 20,
  IdTinh: "0",
  IdHuyen: "0",
  IdXa: "0",
  sHoVaTen: "",
  sTrangThai: "ChoXuLy",
  iTotal: 0,
  lstDanhSach : [],
  IdCuaHang:0,
};

const updateDataSearch = (state, action) => ({
  ...action.payload,
});

export const danhSachThongTinVayReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_SEARCHTDATA:
      return updateDataSearch(state, action);
    default:
      return state;
  }
};

export default danhSachThongTinVayReducer;
